import React from "react";

export const TaxCompliance = {
    title: "Tax Compliance",
    subTitleOne:
    <div>
        Personal Returns
        <br />
        start at $500
    </div>,
    subTitleTwo:
    <div>
        Business Returns
        <br />
        start at $1500
    </div>,
    description:
    <div>
        When you just need a tax return prepared.
        <br />
        <i>Billed monthly for 12 months</i>
    </div>,
    listHeader: "Includes",
    listElements: [
      "Tax Return Preparation",
      "Tax Return Review",
      "Digital Document Storage",
    ]
};



// WEBPACK FOOTER //
// ./src/components/Packages/constants/TaxCompliance.constants.js